import React, { useState, useEffect, useContext, useRef } from 'react';
import axios from '../../../../axios/index';
import { useHistory, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

// context
import { UserContext } from '../../../Context/UserContextProvider';

// Re Useable Components
import { ToastContainer, toast } from 'react-toastify';
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import DashboardHeader from '../../DashboardReuseAbleComponents/DashboardHeader';
import ConsultantsList from './ConsultantsList';
import SelectedConsultants from './SelectedConsultants';
import SuccessModal from './SuccessModal';
import ShowProfileModal from '../../DashboardFileManagement/CardDetail/ShowProfileModal';

// styles
import styles from "./ShareToConsultant.module.css"
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css"
import 'react-toastify/dist/ReactToastify.css';

// Images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg"
import searchIcon from "../../../../assets/img/DashboardICons/SearchIconBlue.svg"

const ShareToConsultant = () => {
    const { userToken } = useContext(UserContext);
    const { state } = useLocation();
    const history = useHistory();
    const [query, setQuery] = useState("");
    const [showLists, setShowLists] = useState(false)
    const [modalShow, setModalShow] = useState(false);
    const [modalShow2, setModalShow2] = useState(false);
    const [selectedConsultants, setSelectedConsultants] = useState([])
    const [consultantData, setconsultantData] = useState([])
    const [btnLoader, setBtnLoader] = useState(false)
    const dropdownRef = useRef(null);

    const handleBlur = () => {
        setTimeout(() => {
            if (!dropdownRef.current.contains(document.activeElement)) {
                setShowLists(false);
            }
        }, 300);
    };

    const inputHandler = (event) => {
        var lowerCase = event.target.value.toLowerCase();
        setQuery(lowerCase);
    };

    const search = (data) => {
        const updatedArray = data.map(obj => ({
            ...obj,
            fullName: `${obj.name} ${obj.family}`
        }));

        return updatedArray.filter((item) => item.fullName.toLowerCase().includes(query));
    };

    useEffect(() => {
        const getData = async () => {
            const getApiData = await axios.get(
                "Consultant?Take=1000000000",
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            // console.log(getApiData.data.data.data)
            setconsultantData(getApiData.data.data.data)
        }
        getData()
    }, [userToken])

    return (
        <>
            <SuccessModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            <ShowProfileModal
                show={modalShow2}
                onHide={() => setModalShow2(false)}
            />

            <div className='container-fluid'>

                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover={false}
                    theme="light"
                />

                <div className='row'>
                    <div className="col-md-9" >
                        <div className={`mt-3 px-0 ${Dstyles.container}`}>
                            <DashboardHeader onClick={() => setModalShow2(true)} />

                            {/* header title start */}
                            <div className="py-2">
                                <div className="container-fluid">
                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 pe-md-4 pe-0"
                                        dir="rtl"
                                    >
                                        <div className='w-100 d-flex align-items-center justify-content-center justify-content-md-start flex-wrap mt-2 mb-2 '>
                                            <Link to={{
                                                pathname: `/card-detail/${state}`,
                                                state: {
                                                    id: state
                                                }
                                            }}><img className='ms-2' src={arrowIcon} alt="icon" /></Link>
                                            <div className={Dstyles.text1}>
                                                اشتراک‌گذاری با مشاور
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* header title end */}

                            {/* search bar start */}
                            <div className="py-2" style={{ height: "330px" }}>
                                <div className="container-fluid">
                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 pe-md-4 pe-0"
                                        dir="rtl"
                                    >
                                        <div className='w-100 d-flex flex-column align-items-md-start align-items-start justify-content-center flex-wrap mt-2 mb-2 '>
                                            <div className={`d-flex align-items-center justify-content-center ${styles.searchbox_container}`} style={{ borderColor: showLists && "#21409a" }}>
                                                <input className={styles.searchbox} type="text" name="query" value={query} onChange={inputHandler} onBlur={handleBlur} ref={dropdownRef} onFocus={() => setShowLists(true)} placeholder='جستجو نام یا کد پرسنلی مشاور' />

                                                <div className={`d-flex align-items-center justify-content-center ${styles.serach_btn}`} onClick={() => dropdownRef.current.focus()}>
                                                    <img className={styles.searchbox_icon} src={searchIcon} alt="icon" />
                                                    پیدا کن
                                                </div>
                                            </div>
                                            {showLists &&
                                                <ConsultantsList consultantsList={search(consultantData)} selectedConsultants={selectedConsultants} setSelectedConsultants={setSelectedConsultants} setShowLists={setShowLists} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* search bar end */}

                            {/* selected consultants start */}
                            <SelectedConsultants selectedConsultants={selectedConsultants} setSelectedConsultants={setSelectedConsultants} />
                            {/* selected consultants end */}

                            {/* btn */}
                            <div className="py-2">
                                <div className="container-fluid">
                                    <div
                                        className="w-100 d-flex justify-content-end align-items-center mt-4 ms-md-3 ms-0 mb-4"
                                        dir="rtl"
                                    >
                                        {btnLoader ? (
                                            <div className={styles.btn_loader_container}>
                                                <div className={styles.btn_spinner}></div>
                                            </div>
                                        )
                                            : (
                                                selectedConsultants == "" ?
                                                    <button type="" className={styles.btn_disabled}>تایید</button>
                                                    :
                                                    <button type="" className={styles.btn_active} onClick={submitHandler}>تایید</button>
                                            )
                                        }


                                    </div>
                                </div>
                            </div>
                            {/* btn */}
                        </div>
                    </div>
                    <div className='col-md-3'>
                        {/* sideMenu starts */}
                        <DashboardSideMenu addNewFile />
                        {/* sideMenu ends */}
                    </div>
                </div>
            </div>
        </>
    );

    function submitHandler(event) {
        event.preventDefault();
        if (selectedConsultants == []) {
            notify("لطفا حداقل یک مشاور انتخاب", "error")
        } else {
            notify("درحال افزودن فایل شما به مشاور انتخاب شده", "success")
        }
    }

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            postHandler()
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setBtnLoader(false)
        }
    };

    async function postHandler() {
        setBtnLoader(true)
        var data = new FormData();
        data.append('EstateId', state);
        for (const item of selectedConsultants) {
            data.append('ConsultantIds', item.id);
        }

        const apiData = await axios.post(
            "Estate/addConsultant",
            data,
            {
                headers: { authorization: "Bearer " + userToken },
            }
        );
        // console.log(apiData)
        setBtnLoader(false)
        setModalShow(true)
        history.push({
            pathname: `/card-detail/${state}`,
            state: {
                id: state
            }
        })
        // pathname: '/template',
        // search: '?query=abc',
        // state: { detail: response.data }
    }

};

export default ShareToConsultant;